import { Checkbox, Grid, Typography } from '@material-ui/core'
import { useCallback, useEffect, useState } from 'react'

import { SelecionarData } from 'components'
import { Autocomplete } from 'components/Autocomplete'
import { WrapperFiltros } from 'components/WrapperFiltros'
import { getLabelClassificacaoCadaver, getLabelResultadoExameNecropapiloscopicoCadaver } from 'helpers/labels'
import { useCadaverService } from 'hooks/useCadaverService'
import { useExameNecroscopicoService } from 'hooks/useExameNecroscopicoService'
import { useFormState } from 'hooks/useFormState'
import { useSetorService } from 'hooks/useSetorService'
import useStyles from './styles'

export const FiltrosBancoCadaveres = (props) => {
  const { setCadaveres, setProcessandoCadaveres } = props
  const classes = useStyles()
  const cadaverService = useCadaverService()
  const setorService = useSetorService()
  const exameNecroscopicoService = useExameNecroscopicoService()
  const [options, setOptions] = useState({ necroterios: [], causasMorte: [] })
  const [processandoOptions, setProcessandoOptions] = useState(true)
  const [optionsError, setOptionsError] = useState(false)

  const formFiltroCadaveres = useFormState(
    {},
    {
      necroterios: [],
      status: [],
      classificacao: [],
      cidades: [],
      causaMorte: [],
      dataEntradaInicio: new Date(),
      dataEntradaFinal: new Date(),
      resultadoExame: [],
      dataEntradaChecked: false,
    }
  )

  const filtrarCadaveres = useCallback(async () => {
    const dataInicioFormatada = new Date(formFiltroCadaveres.formState.values.dataEntradaInicio)
    dataInicioFormatada.setHours(0, 0, 0, 0)
    const dadosFormatados = {
      ...formFiltroCadaveres.formState.values,
      dataEntradaInicio: dataInicioFormatada,
    }
    const response = await cadaverService.listarCadaveresFiltradosAsync(dadosFormatados, setProcessandoCadaveres)
    setCadaveres(response)
  }, [formFiltroCadaveres.formState.values])

  useEffect(() => {
    let mounted = true

    const fetchOptions = async () => {
      try {
        const [necroterios, causasMorte] = await Promise.all([setorService.listarSetoresNecroterioAsync(), exameNecroscopicoService.listarCausasMorteGlobal()])

        if (!mounted) return

        if (!necroterios || !causasMorte) {
          setOptionsError(true)
        }

        setOptions({
          necroterios: necroterios || [],
          causasMorte: causasMorte || [],
        })
      } catch (error) {
        if (mounted) setOptionsError(true)
      } finally {
        if (mounted) setProcessandoOptions(false)
      }
    }

    fetchOptions()

    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    filtrarCadaveres()
  }, [])

  useEffect(() => {
    if (!formFiltroCadaveres.formState.values.dataEntradaFinal) {
      const dataAtual = new Date()
      dataAtual.setHours(0, 0, 0, 0)
      const dataDiaAnterior = new Date(dataAtual.getTime())
      dataDiaAnterior.setDate(dataAtual.getDate() - 1)
      formFiltroCadaveres.setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          dataEntradaInicio: dataDiaAnterior,
          dataEntradaFinal: dataAtual,
        },
      }))
    }
  }, [])

  const handleLimparFiltros = useCallback(async () => {
    formFiltroCadaveres.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        necroterios: [],
        status: [],
        classificacao: [],
        cidades: [],
        causaMorte: [],
        dataEntradaInicio: new Date(),
        dataEntradaFinal: new Date(),
        resultadoExame: [],
        dataEntradaChecked: false,
      },
    }))

    const response = await cadaverService.listarCadaveresFiltradosAsync(
      {
        necroterios: [],
        status: [],
        classificacao: [],
        cidades: [],
        causaMorte: [],
        dataEntradaInicio: new Date(),
        dataEntradaFinal: new Date(),
        resultadoExame: [],
      },
      setProcessandoCadaveres
    )
    setCadaveres(response)
  }, [formFiltroCadaveres])

  return (
    <WrapperFiltros handleLimparFiltros={handleLimparFiltros} handleFiltrar={filtrarCadaveres} error={optionsError} >
      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Identificação e Status
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.field}>
            <Autocomplete
              value={formFiltroCadaveres.formState.values.necroterios}
              multiple
              name="necroterios"
              loading={processandoOptions}
              options={options.necroterios}
              onChange={(event, newValue) => {
                formFiltroCadaveres.handleChangeNewValueByNameProperty(event, newValue, 'necroterios')
              }}
              getOptionLabel={(option) => `${option.nome} / ${option.divisao.sigla} / ${option.divisao.regional.nome} / ${option.divisao.regional.orgao.sigla}`.toUpperCase()}
              getTagTooltip={(option) => `${option.nome} / ${option.divisao.sigla} / ${option.divisao.regional.nome} / ${option.divisao.regional.orgao.sigla}`.toUpperCase()}
              getTagLabel={(option) => `${option.nome} / ${option.divisao.regional.nome}`.toUpperCase()}
              label="NECROTÉRIO"
            />
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <Autocomplete
              value={formFiltroCadaveres.formState.values.status}
              multiple
              name="status"
              options={['PENDENTE', 'LIBERADO', 'ENTREGUE', 'INUMADO']}
              onChange={(event, newValue) => {
                formFiltroCadaveres.handleChangeNewValueByNameProperty(event, newValue, 'status')
              }}
              label="STATUS"
            />
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <Autocomplete
              value={formFiltroCadaveres.formState.values.classificacao}
              multiple
              name="classificacao"
              options={['NAO_IDENTIFICADO', 'IDENTIFICADO', 'NECROPAPILOSCOPICO_POSITIVO', 'RECONHECIDO']}
              onChange={(event, newValue) => {
                formFiltroCadaveres.handleChangeNewValueByNameProperty(event, newValue, 'classificacao')
              }}
              getOptionLabel={getLabelClassificacaoCadaver}
              label="CLASSIFICAÇÃO DA IDENTIFICAÇÃO"
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Exames e Ocorrência
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.field}>
            <Autocomplete
              name="causaMorte"
              multiple
              value={formFiltroCadaveres.formState.values.causaMorte}
              loading={processandoOptions}
              options={options.causasMorte}
              getOptionLabel={(option) => option.nome?.toUpperCase()}
              onChange={(event, newValue) => {
                formFiltroCadaveres.handleChangeNewValueByNameProperty(event, newValue, 'causaMorte')
              }}
              label="CAUSA DA MORTE"
            />
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <Autocomplete
              value={formFiltroCadaveres.formState.values.resultadoExame}
              multiple
              name="resultadoExame"
              options={['IDENTIFICADO_DOCUMENTO', 'NAO_IDENTIFICADO_DOCUMENTO', 'IDENTIFICADO_SISTEMA', 'NAO_IDENTIFICADO_SISTEMA', 'NAO_IDENTIFICADO_FALTA_DOCUMENTO', 'NAO_IDENTIFICADO_SEM_IMPRESSAO_PAPILAR']}
              onChange={(event, newValue) => {
                formFiltroCadaveres.handleChangeNewValueByNameProperty(event, newValue, 'resultadoExame')
              }}
              getOptionLabel={getLabelResultadoExameNecropapiloscopicoCadaver}
              label="RESULTADO EXAME NECROPAPILOSCÓPICO"
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Período
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.itemData}>
            <Grid alignItems="center" container spacing={1}>
              <Grid item xs={2}>
                <Checkbox checked={formFiltroCadaveres.formState.values.dataEntradaChecked || false} onChange={formFiltroCadaveres.handleChange} name="dataEntradaChecked" />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData
                  dataBD={formFiltroCadaveres.formState.values.dataEntradaInicio}
                  withoutTime
                  callback={(valor) => formFiltroCadaveres.handleChangeCampoData('dataEntradaInicio', valor)}
                  label="Entrada - Início"
                  disabled={!formFiltroCadaveres.formState.values.dataEntradaChecked}
                  name="dataEntradaInicio"
                  maxDate={formFiltroCadaveres.formState.values.dataEntradaFinal}
                />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData
                  dataBD={formFiltroCadaveres.formState.values.dataEntradaFinal}
                  withoutTime
                  callback={(valor) => formFiltroCadaveres.handleChangeCampoData('dataEntradaFinal', valor)}
                  label="Entrada - Final"
                  disabled={!formFiltroCadaveres.formState.values.dataEntradaChecked}
                  name="dataEntradaFinal"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </WrapperFiltros>
  )
}
